import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Download } from '~/components/';
import downloadFile from '~/utils/downloadFile';
import { useSelector } from 'react-redux';
import InfoTitle from '../../InfoTitle';
import * as S from '../styles';

export default function KitTeam({ kits, selectedMatch, publicFiles }) {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [pdfLoading, setPdfLoading] = useState(false);

  return (
    <>
      <S.TeamColumn type="local">
        <S.TeamHeader type="local">
          <p>{t('equipment')}</p>
          <p>{selectedMatch ? selectedMatch.homeTeam.nickname : ''}</p>
        </S.TeamHeader>
        <S.ShieldBackground
          image={selectedMatch ? selectedMatch.homeTeam.shieldImageUrl : ''}
          type="local"
        />
        <S.KitDisplayColumn type="local">
          <S.KitColumn>
            {kits.homeTeamPlayer && (
              <>
                <S.ShirtTile image={kits.homeTeamPlayer.tshirtImage} />
                <S.PantsTile image={kits.homeTeamPlayer.shortsImage} />
                <S.SocksTile image={kits.homeTeamPlayer.socksImage} />
                <InfoTitle
                  title={t('shirt')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamPlayer.tshirtNumber
                    ? `${kits.homeTeamPlayer.tshirtNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('shorts')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamPlayer.shortsNumber
                    ? `${kits.homeTeamPlayer.shortsNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('socks')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamPlayer.socksNumber
                    ? `${kits.homeTeamPlayer.socksNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
              </>
            )}
          </S.KitColumn>
          <S.KitColumn>
            {kits.homeTeamGoalkeeper && (
              <>
                <S.ShirtTile image={kits.homeTeamGoalkeeper.tshirtImage} />
                <S.PantsTile image={kits.homeTeamGoalkeeper.shortsImage} />
                <S.SocksTile image={kits.homeTeamGoalkeeper.socksImage} />
                <InfoTitle
                  title={t('shirt')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamGoalkeeper.tshirtNumber
                    ? `${kits.homeTeamGoalkeeper.tshirtNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('shorts')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamGoalkeeper.shortsNumber
                    ? `${kits.homeTeamGoalkeeper.shortsNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('socks')}
                  textColor="dark"
                  borderColor="coral"
                >
                  {kits.homeTeamGoalkeeper.socksNumber
                    ? `${kits.homeTeamGoalkeeper.socksNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
              </>
            )}
          </S.KitColumn>
        </S.KitDisplayColumn>
      </S.TeamColumn>
      <S.StatsColum>
        <S.TeamHeader type="referee">
          <p>{t('equipment')}</p>
          <p>{t('referee')}</p>
        </S.TeamHeader>
        <S.KitDisplayColumn type="referee">
          <S.KitColumn>
            {kits.referee && (
              <>
                <S.ShirtTile image={kits.referee.tshirtImage} />
                <S.PantsTile image={kits.referee.shortsImage} />
                <S.SocksTile image={kits.referee.socksImage} />
                <InfoTitle
                  title={t('shirt')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.referee.tshirtNumber
                    ? `${kits.referee.tshirtNumber}${t('countAcronim')} ${t(
                        'equipment'
                      )}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('shorts')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.referee.shortsNumber
                    ? `${kits.referee.shortsNumber}${t('countAcronim')} ${t(
                        'equipment'
                      )}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('socks')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.referee.socksNumber
                    ? `${kits.referee.socksNumber}${t('countAcronim')} ${t(
                        'equipment'
                      )}`
                    : '-'}
                </InfoTitle>
              </>
            )}
          </S.KitColumn>
        </S.KitDisplayColumn>
      </S.StatsColum>
      <S.TeamColumn type="away">
        <S.TeamHeader type="visitor">
          <p>{t('equipment')}</p>
          <p>{selectedMatch ? selectedMatch.awayTeam.nickname : ''}</p>
        </S.TeamHeader>
        <S.ShieldBackground
          image={selectedMatch ? selectedMatch.awayTeam.shieldImageUrl : ''}
          type="away"
        />
        <S.KitDisplayColumn type="away">
          <S.KitColumn>
            {kits.visitorTeamPlayer && (
              <>
                <S.ShirtTile image={kits.visitorTeamPlayer.tshirtImage} />
                <S.PantsTile image={kits.visitorTeamPlayer.shortsImage} />
                <S.SocksTile image={kits.visitorTeamPlayer.socksImage} />
                <InfoTitle
                  title={t('shirt')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamPlayer.tshirtNumber
                    ? `${kits.visitorTeamPlayer.tshirtNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('shorts')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamPlayer.shortsNumber
                    ? `${kits.visitorTeamPlayer.shortsNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('socks')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamPlayer.socksNumber
                    ? `${kits.visitorTeamPlayer.socksNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
              </>
            )}
          </S.KitColumn>
          <S.KitColumn>
            {kits.visitorTeamGoalkeeper && (
              <>
                <S.ShirtTile image={kits.visitorTeamGoalkeeper.tshirtImage} />
                <S.PantsTile image={kits.visitorTeamGoalkeeper.shortsImage} />
                <S.SocksTile image={kits.visitorTeamGoalkeeper.socksImage} />
                <InfoTitle
                  title={t('shirt')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamGoalkeeper.tshirtNumber
                    ? `${kits.visitorTeamGoalkeeper.tshirtNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('shorts')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamGoalkeeper.shortsNumber
                    ? `${kits.visitorTeamGoalkeeper.shortsNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
                <InfoTitle
                  title={t('socks')}
                  textColor="white"
                  borderColor="coral"
                >
                  {kits.visitorTeamGoalkeeper.socksNumber
                    ? `${kits.visitorTeamGoalkeeper.socksNumber}${t(
                        'countAcronim'
                      )} ${t('equipment')}`
                    : '-'}
                </InfoTitle>
              </>
            )}
          </S.KitColumn>
        </S.KitDisplayColumn>
      </S.TeamColumn>
      <Download
        onClick={() => {
          if (publicFiles.data.kitselector)
            downloadFile(publicFiles.data.kitselector.id, setPdfLoading);
        }}
        disabled={
          Object.keys(publicFiles.data).length === 0 ||
          !publicFiles.data.kitselector
        }
        text={t('downloadKitDesignation')}
        loading={pdfLoading}
        competition={match?.competitionId}
      />
    </>
  );
}

KitTeam.propTypes = {
  selectedMatch: PropTypes.object,
  kits: PropTypes.object,
  publicFiles: PropTypes.object,
};

KitTeam.defaultProps = {
  selectedMatch: {},
  kits: {},
  publicFiles: { data: {} },
};
